import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { injectIntl } from 'react-intl';
import { deepExtract } from 'helpers/deep';
import { loadRadius } from './filters.saga';
import { searchFilterActions } from './filters.helpers';
import { AUTO_RADIUS_ID, FILTER_NAMES } from '../Search.constants';
import { RadiusFilter } from '../components/filters/RadiusFilter';
import { selectLocationAutocompleteFromSearchResults } from '../Search.helpers';

const { setFilterEditing } = searchFilterActions;
const { RADIUS } = FILTER_NAMES;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const itemsById = deepExtract('radius.itemsById', filters, {});
  const selectedId = deepExtract(`${RADIUS}.value`, filters, AUTO_RADIUS_ID);
  const isEditing = deepExtract(`${RADIUS}.isEditing`, filters, false);
  const isSelected = deepExtract(`${RADIUS}.filtered`, filters, false);
  const selectedRadius = itemsById[selectedId];
  const locationAutoComplete = selectLocationAutocompleteFromSearchResults(state);
  const isAutoLocationAvailable = Object.keys(locationAutoComplete).length > 0;

  return {
    items: itemsById ? Object.values(itemsById) : [],
    isMobile: selectIsMobile(state),
    isSelected,
    selectedId,
    selectedRadius,
    isAutoLocationAvailable,
    isEditing,
  };
};

export const mapDispatchToProps = {
  loadRadius: () => loadRadius(),
  onSetIsEditing: isEditing => setFilterEditing(RADIUS, isEditing),
};

const RadiusFilterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(RadiusFilter));

export { RadiusFilterContainer };
